<template>
 <div class="diy-full-screen-container">
  <div class="screen-container" :class="{ usingDarkTheme }">
   <TheHeader @changeTheme="changeTheme" />
   <main>
    <div class="left">
     <ZheXianTongJi :dataByMap="dataByMap.ZheXianTongJi" />
     <BingZhuangTu ref="bing_zhuang_tu" :dataByMap="dataByMap.BingZhuangTu" @fanclick="changeLunBoBiaoDataByFan" />
    </div>
    <div class="center">
     <FeiXianTu :hideTip="showCompanyDialog" @mapchange="onMapChange" />
    </div>
    <div class="right">
     <PaiHangBangLunBoBiao :usingDarkTheme="usingDarkTheme" :dataByMap="dataByMap.PaiHang"  />
     <div class="gap" style="height:40px"></div>
     <ZuiXinLunBoBiao :usingDarkTheme="usingDarkTheme" @rowItemClick="rowItemClick($event)"
      :dataByMap="dataByMap.ZuiXinLunBoBiao" />
    </div>
   </main>
  </div>

  <div class="spin" @click="$emit('spinScreen')">
   <svg t="1688958389067" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
    p-id="2270" width="200" height="200">
    <path
     d="M629.556904 391.972323c17.328667 17.319457 47.028083 17.319457 66.814732 0l168.302147-165.81449 0 133.63765c0 19.805068 14.85022 34.646078 34.636868 34.646078l24.743544 0c19.806091 0 34.656311-12.371772 34.656311-29.691229L958.710506 119.732965l-2.478448 0 2.478448-17.318434c0-9.903557-2.478448-17.328667-7.435343-24.75173-4.936429-4.947685-14.848173-9.894348-24.743544-9.894348l-17.326621 0 0 0L664.211169 65.290005c-19.805068 0-34.654264 17.328667-34.654264 34.646078l0 24.75173c2.478448 22.274306 19.788695 34.646078 39.59274 34.646078l128.690988 0L632.035352 325.149405C609.751836 342.467839 609.751836 372.175441 629.556904 391.972323L629.556904 391.972323 629.556904 391.972323zM394.441049 629.557416c-17.310248-17.327644-47.00864-17.327644-66.814732 0l-168.301124 165.806303L159.325194 664.195308c0-19.787672-14.8318-34.637892-34.636868-34.637892l-24.76094 0c-19.787672 0-34.637892 12.371772-34.637892 29.698392l0 242.532779 2.477424 0-2.477424 17.327644c0 9.893324 2.477424 17.310248 7.4159 24.743544 4.955872 4.955872 14.867616 9.894348 24.76094 9.894348l17.327644 0 0 0 244.992807 2.477424c19.823488 0 34.655288-17.327644 34.655288-34.637892l0-24.759917c-2.478448-22.26612-19.787672-34.637892-39.59274-34.637892l-128.690988 0 168.283728-165.8237C411.768693 679.044504 411.768693 649.345088 394.441049 629.557416L394.441049 629.557416 394.441049 629.557416zM956.231035 904.266012 956.231035 661.71686c0-19.787672-17.328667-29.680996-34.638915-29.680996l-24.758893 0c-19.788695 0-34.638915 17.309224-34.638915 34.637892l0 131.168412L693.893188 632.035864c-17.308201-17.328667-47.00864-17.328667-66.814732 0-17.326621 17.309224-17.326621 47.00864 0 66.813708l168.283728 165.806303-128.690988 0c-19.786649 0-37.115316 12.388145-39.59274 34.654264l0 24.744567c0 19.805068 17.328667 34.654264 34.638915 34.654264l240.071727-2.478448 0 0 17.328667 0c9.893324 0 17.310248-2.477424 24.743544-9.893324 4.954849-4.955872 7.414877-14.85022 7.414877-24.744567L956.231035 904.266012C953.752588 904.266012 956.231035 904.266012 956.231035 904.266012L956.231035 904.266012 956.231035 904.266012zM228.635769 159.334915l128.690988 0c19.805068 0 37.115316-12.372795 39.59274-34.646078L396.919497 99.936083c0-19.796882-17.309224-34.646078-34.654264-34.646078l-244.992807 2.478448 0 0-17.34504 0c-9.875928 0-17.310248 2.477424-24.743544 9.894348-4.938476 4.955872-7.4159 14.849196-7.4159 24.75173l2.477424 17.318434-2.477424 0 0 245.01839c0 19.796882 14.85022 29.691229 34.637892 29.691229l24.743544 0c19.822464 0 34.654264-14.84101 34.654264-34.646078L161.803641 226.157833l168.283728 165.81449c17.34504 17.319457 47.044456 17.319457 66.832128 0 17.328667-17.327644 17.328667-47.026036 0-66.822918L228.635769 159.334915 228.635769 159.334915 228.635769 159.334915zM228.635769 159.334915"
     fill="#ffffff" p-id="2271"></path>
   </svg>
  </div>
  <transition name="fade">
   <CompanyDetailDialog v-if="showCompanyDialog" @close="showCompanyDialog = false"
    :companyDetail="companyDetailDialogData" />
  </transition>


 </div>
</template>

<script>
import ZheXianTongJi from './components/ZheXianTongJi.vue'
import BingZhuangTu from './components/BingZhuangTu.vue'
import TheHeader from '@/components/TheHeader.vue'
import ZuiXinLunBoBiao from './components/ZuiXinLunBoBiao.vue'
import PaiHangBangLunBoBiao from './components/PaiHangBangLunBoBiao.vue'
import FeiXianTu from './components/FeiXianTu.vue'

import CompanyDetailDialog from './components/dialogs/CompanyDetailDialog.vue'


export default {
 data() {
  return {
   usingDarkTheme: false,
   showUserDialog: false,
   showCompanyDialog: false,
   companyDetailDialogData: {},
   dataByMap: {
    BingZhuangTu: [],
    ZheXianTongJi: [],
    ZuiXinLunBoBiao: [],
    PaiHang:[]
   }
  }
 },
 mounted() {
  this.$emit("setBodyBackground", this.usingDarkTheme)
  this.$emit("resetContaionerSize")
 },
 methods: {
  rowItemClick(item) {
   this.companyDetailDialogData = item
   this.showCompanyDialog = true
  },
  changeTheme() {
   this.usingDarkTheme = !this.usingDarkTheme
   this.$emit("setBodyBackground", this.usingDarkTheme)
  },
  onMapChange(json) {
   // 地图修改后会把页面静态数据传递过来，包括地图数据
   let { pageData,features } = json
   // pageData 静态数据 features 地图数据
   // 拿到 子区域名字 和 邮政编码 放到排行榜组件里面
   let PaiHang=features.map(e=>[e.properties.name,e.properties.adcode])
   ;` <PaiHangBangLunBoBiao :dataByMap="dataByMap.PaiHang"  />`;
   this.dataByMap = {...pageData.data,PaiHang}
  },
  changeLunBoBiaoDataByFan(data) {
   this.dataByMap.ZuiXinLunBoBiao = data
  }
 },
 components: {
  TheHeader,
  ZheXianTongJi,
  BingZhuangTu,
  ZuiXinLunBoBiao,
  PaiHangBangLunBoBiao,
  FeiXianTu,
  CompanyDetailDialog
 }
}
</script>

<style  scoped lang="less">
.diy-full-screen-container {
 width: 1920px;
 height: 1080px;
 transform-origin: center;
 transform: translate(-50%, -50%) scale(1);
 position: absolute;
 left: 50%;
 top: 50%;
}

.screen-container {
 width: 100%;
 height: 100%;
 display: flex;
 flex-direction: column;

}

main {
 padding: 0px 35px 45px 32px;
 box-sizing: border-box;
 color: white;
 flex: 1;
 display: flex;

 .left,
 .right {
  display: flex;
  flex-direction: column;
  flex: 1;
 }

 .center {

  display: flex;
  flex-direction: column;
  width: 800px;
  height: 900px;
  margin: 0 20px;
 }

}

// 以下是动画
.fade-enter-active,
.fade-leave-active {
 transition: opacity .1s linear;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
 {
 opacity: 0;
}
</style>
